import { useEffect, useState } from "react";
import { WifiOff, Download, X } from "lucide-react";

export const PwaLayer = () => {
  const [offline, setOffline] = useState(!navigator.onLine);
  const [installEvt, setInstallEvt] = useState(null);
  const [dismissed, setDismissed] = useState(localStorage.getItem("chimen_pwa_dismissed") === "1");

  useEffect(() => {
    const on = () => setOffline(false);
    const off = () => setOffline(true);
    const beforeInstall = (e) => { e.preventDefault(); setInstallEvt(e); };
    window.addEventListener("online", on);
    window.addEventListener("offline", off);
    window.addEventListener("beforeinstallprompt", beforeInstall);
    return () => {
      window.removeEventListener("online", on);
      window.removeEventListener("offline", off);
      window.removeEventListener("beforeinstallprompt", beforeInstall);
    };
  }, []);

  const install = async () => {
    installEvt.prompt();
    await installEvt.userChoice;
    setInstallEvt(null);
  };

  const dismiss = () => {
    setDismissed(true);
    localStorage.setItem("chimen_pwa_dismissed", "1");
  };

  return (
    <>
      {offline && (
        <div className="fixed bottom-0 inset-x-0 z-[60] bg-foreground text-background text-sm px-6 py-2.5 flex items-center justify-center gap-2" data-testid="offline-banner">
          <WifiOff size={15} /> Mode hors ligne — les contenus déjà consultés restent disponibles
        </div>
      )}
      {installEvt && !dismissed && (
        <div className="fixed bottom-4 right-4 z-[60] bg-card border border-primary/25 rounded-lg shadow-xl p-4 flex items-center gap-3 max-w-xs" data-testid="install-prompt">
          <img src="/icon-192.png" alt="" className="w-10 h-10 rounded-lg" />
          <div className="flex-1">
            <p className="text-sm font-medium">Installer Chimen Nanm</p>
            <button onClick={install} className="mt-1.5 inline-flex items-center gap-1.5 text-xs px-3 py-1.5 rounded-full bg-primary text-primary-foreground hover:bg-[#16528A] transition-colors duration-200" data-testid="install-btn">
              <Download size={12} /> Installer l'application
            </button>
          </div>
          <button onClick={dismiss} className="text-muted-foreground hover:text-foreground" data-testid="install-dismiss"><X size={14} /></button>
        </div>
      )}
    </>
  );
};
